module.exports = __webpack_public_path__ + "img/snihDoleBackground.277e23b7.png";